import { useGetPecas } from '../../hook/getPecas';
import { useEffect, useState } from 'react';
import { Card, Typography, CardBody } from '@material-tailwind/react';
import { ChevronUpDownIcon } from '@heroicons/react/24/outline';
import TrTableTd from '../Table/TrTableTd';

const PecasEnEquipamentoTable = ({ id }) => {
  const { result, patch, loading } = useGetPecas(id);
  const [newPec, setNewPec] = useState(false);

  useEffect(() => {
    patch(id);
  }, [id]);

  useEffect(() => {
    if (newPec) {
      patch();
      setTimeout(() => {
        setNewPec(false);
      }, 1000);
    }
  }, [newPec]);

  const TABLE_HEAD = ['Produto', 'Quantidade', 'Codigo', 'Ações'];

  return (
    <Card className="h-full w-full mt-2  overflow-x-auto ">
      {result.length > 0 && (
        <CardBody className="overflow-scroll px-0 py-0 bg-gray-400 ">
          <table className="mt-0  w-full min-w-max table-auto text-left overflow-auto border-none">
            <thead>
              <tr>
                {TABLE_HEAD.map((head, index) => (
                  <th
                    key={head}
                    className={`cursor-pointer border-y  p-5 transition-colors bg-lightTh  border-t-0`}
                  >
                    <Typography
                      color="white"
                      variant="h6"
                      className="flex items-center justify-between gap-2 leading-none dark:opacity-100 font-extrabold"
                    >
                      {head}
                      {index !== TABLE_HEAD.length - 1 && (
                        <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 " />
                      )}
                    </Typography>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Object.entries(result).map(([key, item], index) => (
                <TrTableTd
                  key={key}
                  item={item}
                  index={index}
                  result={result.length}
                  setNewPec={setNewPec}
                />
              ))}
            </tbody>
          </table>
        </CardBody>
      )}
      {result.length === 0 && (
        <Typography color="red" className="rounded-none text-center font-bold">
          Nenhuma peça cadastrada
        </Typography>
      )}
    </Card>
  );
};

export default PecasEnEquipamentoTable;
